import React, { useState } from "react";
import { Facebook, Twitter, Linkedin, Link2, Check, MessageCircle } from "lucide-react";
import { useLanguage } from "../../context/LanguageContext";

const LABELS = {
  es: { share: "Comparte RapidPay", copied: "¡Enlace copiado!", copy: "Copiar enlace" },
  en: { share: "Share RapidPay", copied: "Link copied!", copy: "Copy link" },
  pt: { share: "Compartilhe a RapidPay", copied: "Link copiado!", copy: "Copiar link" },
};

const SHARE_TEXT = {
  es: "Descubre RapidPay: la pasarela de pagos de Panamá. Cobra con tarjetas, Yappy y ACH.",
  en: "Discover RapidPay: Panama's payment gateway. Accept cards, Yappy and ACH.",
  pt: "Conheça a RapidPay: o gateway de pagamentos do Panamá. Receba com cartões, Yappy e ACH.",
};

export const ShareButtons = () => {
  const { lang } = useLanguage();
  const [copied, setCopied] = useState(false);
  const labels = LABELS[lang] || LABELS.es;
  const text = SHARE_TEXT[lang] || SHARE_TEXT.es;
  const url = typeof window !== "undefined" ? window.location.origin : "https://rapidpaypro.com";
  const encUrl = encodeURIComponent(url);
  const encText = encodeURIComponent(text);

  const networks = [
    { id: "whatsapp", icon: MessageCircle, href: `https://wa.me/?text=${encText}%20${encUrl}`, title: "WhatsApp" },
    { id: "facebook", icon: Facebook, href: `https://www.facebook.com/sharer/sharer.php?u=${encUrl}`, title: "Facebook" },
    { id: "twitter", icon: Twitter, href: `https://twitter.com/intent/tweet?text=${encText}&url=${encUrl}`, title: "X / Twitter" },
    { id: "linkedin", icon: Linkedin, href: `https://www.linkedin.com/sharing/share-offsite/?url=${encUrl}`, title: "LinkedIn" },
  ];

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(url);
    } catch {
      const ta = document.createElement("textarea");
      ta.value = url;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      ta.remove();
    }
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="flex flex-col sm:flex-row items-center gap-3">
      <span className="text-[11px] font-bold uppercase tracking-wider text-white/60">{labels.share}</span>
      <div className="flex items-center gap-2">
        {networks.map((n) => {
          const Icon = n.icon;
          return (
            <a
              key={n.id}
              data-testid={`share-${n.id}`}
              href={n.href}
              target="_blank"
              rel="noopener noreferrer"
              title={n.title}
              className="w-9 h-9 rounded-full bg-white/10 hover:bg-[#0fe814] text-white hover:text-black flex items-center justify-center transition-colors duration-200"
            >
              <Icon size={15} />
            </a>
          );
        })}
        <button
          data-testid="share-copy-link"
          onClick={copyLink}
          title={copied ? labels.copied : labels.copy}
          className="w-9 h-9 rounded-full bg-white/10 hover:bg-[#0fe814] text-white hover:text-black flex items-center justify-center transition-colors duration-200"
        >
          {copied ? <Check size={15} className="text-[#0fe814]" /> : <Link2 size={15} />}
        </button>
      </div>
    </div>
  );
};
